import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {
    ConfigitAceAssignment,
    ConfigitAceConfiguration,
    ConfigitAceConfigureParams,
} from '../models/configit-ace.model';
import { Product } from './products.service';
import { map } from 'rxjs/operators';

interface AceParams {
    salesOrg: string;
    language: string;
}

export interface ConfigureParams extends AceParams {
    productId: string;
    assignments?: ConfigitAceAssignment[];
}

export interface EnergyLabelParams extends AceParams {
    solarUsage?: string;
    productList: Product[];
}

@Injectable({
    providedIn: 'root',
})
export class ConfigitAceService {
    constructor(private http: HttpClient) {}

    public configure(params: ConfigureParams): Observable<ConfigitAceConfiguration> {
        const body = this.configureParams(params);
        return this.http.post<ConfigitAceConfiguration>(`${environment.http.configuration}configit/configure`, body, {
            params: { packagePath: `Internal/master/${params.productId}` },
        });
    }

    public getEnergyLabel({ salesOrg, language, solarUsage, productList }: EnergyLabelParams) {
        const products = productList.map(({ material, quantity }) => ({ material, quantity }));
        const payload = { salesOrg, language, solarUsage, products };

        return this.http
            .post<{ energyLabelHash: string }>(`${environment.http.baseUrl}/configuration/ace/energy-label`, payload)
            .pipe(map((resp) => resp.energyLabelHash));
    }

    private configureParams({
        salesOrg,
        language,
        assignments,
        productId,
    }: ConfigureParams): ConfigitAceConfigureParams {
        const variableAssignments = assignments || [];
        return {
            date: new Date().toISOString(),
            language,
            globalArguments: {
                SalesArea: {
                    SalesOrganization: salesOrg,
                    DistributionChannel: '01',
                    SalesDivision: '01',
                },
                Plant: salesOrg,
            },
            settings: {
                includeConfiguration: true,
                includeMinimalConflictSet: true,
            },
            line: { productId, variableAssignments },
            viewId: 'STANDARDVIEW',
        };
    }
}
